import { type Href, usePathname, useRouter } from 'expo-router';
import { useEffect, useRef } from 'react';
import { useTabsNavigation } from '../contexts/TabsNavigationContext';

/**
 * Tabs keep every section mounted, so a menu jump to a section showed
 * whatever its stack had on top — a lead detail instead of the leads list.
 * The chrome pulses the target tab on every menu navigation; the section's
 * stack answers by popping to its root when a nested screen is showing.
 */
export function usePopToTabRoot(tabRouteName: string, rootHref: Href): void {
  const router = useRouter();
  const pathname = usePathname();
  const navPulse = useTabsNavigation()?.navPulse;
  const lastSeqRef = useRef(navPulse?.seq ?? 0);

  useEffect(() => {
    if (!navPulse || navPulse.tab !== tabRouteName) return;
    if (navPulse.seq === lastSeqRef.current) return;
    lastSeqRef.current = navPulse.seq;
    if (pathname === rootHref) return;
    router.dismissTo(rootHref);
  }, [navPulse, tabRouteName, rootHref, pathname, router]);
}
